import 'css-chunksrc/client/scenes/documentCreation/form/templates/preview/defaultRenderer/styles.scss';export default {
  "renderer": "_renderer_11aac_1"
};